// Stage Mail-3:MailStatusBadge。
//
// DB の machine value(unhandled / handling / completed)を 日本語 i18n + Badge color に変換。
// design §5.2。

import React from "react";
import { Badge } from "../../components/ui/Badge";
import type { MailStatus } from "../../api/mail";

const STATUS_LABEL_JA: Record<MailStatus, string> = {
  unhandled: "未対応",
  handling: "対応中",
  completed: "対応済み",
};

const STATUS_COLOR: Record<MailStatus, "red" | "yellow" | "green"> = {
  unhandled: "red",
  handling: "yellow",
  completed: "green",
};

export interface MailStatusBadgeProps {
  status: MailStatus;
  /** size:sm は padding を詰める */
  size?: "sm" | "md";
}

export function MailStatusBadge({ status, size = "md" }: MailStatusBadgeProps) {
  return (
    <Badge color={STATUS_COLOR[status]} dot={size === "md"}>
      {STATUS_LABEL_JA[status]}
    </Badge>
  );
}

export function mailStatusLabelJa(status: MailStatus): string {
  return STATUS_LABEL_JA[status];
}
